import { isDefined } from '@ac/library-utils/dist/utils';

export const basicDataMap = (value: unknown): string | undefined => {
  return isDefined(value) ? String(value) : undefined;
};
